"use client";

import { useEffect, useState } from "react";
import Footer from "../../Components/Footer/Footer";
// import Nav from "../../Components/Nav/Nav";
import { useParams, useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Nav from "../../Components/Navnew/Nav";
import Klik from "../../Asset/click.png";
import Payme from "../../Asset/payme.png";
import SweetAlert from "react-bootstrap-sweetalert";
import { companyInfo } from "../../data/company";

const fallbackTours = [
  {
    isTop: true,
    _id: "674579310f0debd431d254ea",
    title_eng: "Uzbekistan Grand Tour (10 Days)",
    title_ru: "По городам Узбекистана (10 дней)",
    title_uz: "O‘zbekiston bo‘ylab katta sayohat (10 kun)",
    description_eng:
      "<p>This 10-day cultural journey includes Tashkent, Nukus, Muynak, Khiva, Bukhara, Shakhrisabz, and Samarkand. Explore the Savitsky Museum, the ship cemetery of the Aral Sea, Ichan-Kala fortress in Khiva, the Ark in Bukhara, Timur’s Ak-Saray in Shakhrisabz, and Samarkand’s Registan and more. Includes licensed guides, train tickets, museum entries, and hotel stays.</p>",
    description_ru:
      "<p>10-дневный тур по Узбекистану включает посещение Ташкента, Нукуса, Муйнака, Хивы, Бухары, Шахрисабза и Самарканда. Вы посетите Музей Савицкого, кладбище кораблей Аральского моря, Ичан-Калу, Крепость Арк, дворец Ак-Сарай и площадь Регистан. Тур включает услуги лицензированных гидов, билеты на поезда, входные билеты в музеи и проживание в гостиницах.</p>",
    description_uz:
      "<p>10 kunlik madaniy turda siz Toshkent, Nukus, Mo‘ynoq, Xiva, Buxoro, Shahrisabz va Samarqand shaharlarini ziyorat qilasiz. Savitskiy muzeyi, Orol kemalar qabristoni, Ichan-Qal’a, Ark qal’asi, Ak-Saroy saroyi va Registon maydoni kabi diqqatga sazovor joylar kiritilgan. Tur professional gidlar, poyezd chiptalari, muzeylarga kirish va mehmonxonalarni o‘z ichiga oladi.</p>",
    location: "Toshkent, Nukus, Mo‘ynoq, Xiva, Buxoro, Shahrisabz, Samarqand",
    price: 1800,
    img: "https://tur.web-sayt.uz/uploads/a81a95a7-5f58-42c6-80b6-f5ca51b32679.jpg",
    date: "2024-11-01T09:00:00.000Z",
  },
  {
    isTop: true,
    _id: "674c642e8ae1c4c2bb64d4cb",
    title_eng: "Express Samarkand-Bukhara Tour (2 Days)",
    title_ru: "Самарканд-Бухара за 2 дня",
    title_uz: "Ekspress Samarqand–Buxoro turi (2 kun)",
    description_eng:
      "<p>This express tour includes travel by Afrosiyob high-speed train from Tashkent to Samarkand and Bukhara. Explore Registan, Gur-Emir, Bibi-Khanum Mosque, Shakhi Zinda in Samarkand, and walk through Labi-Hauz, Poi-Kalyan, and Ark fortress in Bukhara. Includes all transfers, entrance tickets, hotel stay, and guided excursions.</p>",
    description_ru:
      "<p>Экспресс-тур включает поездку на скоростном поезде Афросиаб из Ташкента в Самарканд и Бухару. Вы посетите Регистан, Гур-Эмир, мечеть Биби-Ханым, Шахи-Зинда в Самарканде, а также Ляби-Хауз, Пои-Калян и Крепость Арк в Бухаре. Включает трансферы, входные билеты, проживание и экскурсии с гидом.</p>",
    description_uz:
      "<p>Ushbu ekspress turda siz Afrosiyob poyezdi orqali Toshkentdan Samarqand va Buxoroga sayohat qilasiz. Samarqandda Registon, Gur-Emir, Bibi-Xonim, Shohi Zinda, Buxoroda esa Labi-Hovuz, Poi-Kalon majmuasi va Ark qal’asini ziyorat qilasiz. Barcha transferlar, kirish chiptalari, mehmonxona va gid xizmatlari kiritilgan.</p>",
    location: "Toshkent, Samarqand, Buxoro",
    price: 500,
    img: "https://tur.web-sayt.uz/uploads/878654ae-3ff9-468a-b7fc-a29a2f2fcd69.jpg",
    date: "2024-11-15T08:00:00.000Z",
  },
  {
    isTop: true,
    _id: "674c74b38ae1c4c2bb64d591",
    title_eng: "Tashkent-Khiva-Bukhara-Samarkand (7 Days)",
    title_ru: "Ташкент – Хива – Бухара – Самарканд (7 дней)",
    title_uz: "Toshkent – Xiva – Buxoro – Samarqand (7 kunlik sayohat)",
    description_eng:
      "<p>Explore the legendary Silk Road cities: Tashkent, Khiva, Bukhara, and Samarkand in 7 days. Visit Ichan-Kala fortress, Poi-Kalyan complex, Registan Square, Shakhi Zinda necropolis, and more. Includes flights, train tickets, hotel, guides, and transport.</p>",
    description_ru:
      "<p>Исследуйте легендарные города Великого шелкового пути: Ташкент, Хиву, Бухару и Самарканд за 7 дней. Посетите Ичан-Калу, Пои-Калян, площадь Регистан, Шахи-Зинда и многое другое. Включает авиаперелеты, билеты на поезд, гостиницы, гидов и транспорт.</p>",
    description_uz:
      "<p>Buyuk Ipak yo‘li shaharlarini 7 kun ichida kashf eting: Toshkent, Xiva, Buxoro va Samarqand. Ichan-Qal’a, Poi-Kalon, Registon maydoni, Shohi Zinda majmuasi va boshqa yodgorliklarni ko‘rasiz. Uchish, poyezd chiptalari, mehmonxonalar, gid va transport xizmatlari kiritilgan.</p>",
    location: "Toshkent, Xiva, Buxoro, Samarqand",
    price: 1000,
    img: "https://tur.web-sayt.uz/uploads/ff079203-bc06-46ac-8d60-18ea7566c89d.jpg",
    date: "2024-12-10T07:00:00.000Z",
  },
];

const OneTour = () => {
  const { id } = useParams();
  const location = useLocation();
  // console.log(location.search.includes('price'), 'location')
  const urlParams = new URLSearchParams(location.search);
  // Get the value of the 'price' parameter
  const price = urlParams.get("price");
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [paymeShow, setPaymeShow] = useState(false);
  const [clickShow, setClickShow] = useState(false);
  const [bookShow, setBookShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [notSuccess, setNotSuccess] = useState(false);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const lang = window.localStorage.getItem("lang")
    ? window.localStorage.getItem("lang")
    : "en";
  // const [lang, setLanguage] = useState('en')
  // useEffect(()=>{
  //   setLanguage(localStorage.getItem("lang"))
  // },[localStorage])
  const dollar = 11.7;
  const [isloading, setIsLoading] = useState(true);

  // Function to remove strong tags AND their content
  const removeStrongTags = (htmlContent) => {
    if (!htmlContent) return "";
    return htmlContent.replace(/<strong[^>]*>.*?<\/strong>/gi, "");
  };
  useEffect(() => {
    fetch(`https://tur.web-sayt.uz/api/tours/${id}`)
      .then((res) => res.json())
      .then((data) => {
        let select = fallbackTours.filter((item) => item._id === id);
        setData(...select);
        console.log(...select);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(true);
      });
  }, [id]);

  const formBtn = (e) => {
    setTimeout(() => {
      setSuccess(true);
      setBookShow(false);
    }, 1000);
    e.preventDefault();
    if (e.target[0].value.length > 0 && e.target[1].value.length > 0) {
      const botMessege = `
      Здравствуйте, администратор ${companyInfo.brandName}, новое сообщение! 😊%0A
      Название тура  : ${data.title_eng}%0A
      Имя    👤: ${e.target[0].value}%0A
      Фамилия   👤: ${e.target[1].value}%0A
      Телефон номер   📧: ${e.target[2].value}%0A
      `;
      const url = `https://api.telegram.org/bot7859889008:AAHIkSdCOwbYoxmTwIble9J2FXlAKES8vRk/sendMessage?chat_id=-4871883873&text=${botMessege}`;
      async function fetchAsync(url) {
        const response = await fetch(url);
        const data = await response.json();
        return data;
      }
      fetchAsync(url);
      e.target[0].value = "";
      e.target[1].value = "";
      e.target[2].value = "";
    } else {
      setNotSuccess(true);
    }
  };

  const Pay = async () => {
    // let form_data = {
    //   "octo_shop_id": 20216,
    //   "octo_secret": "857e6cfa-9639-4a35-bd0b-b41a71d3c897",
    //   "shop_transaction_id": uuidv4(),
    //   "auto_capture": true,
    //   // "test": true,
    //   "init_time": formatDate(new Date()),
    //   // "total_sum": 0.5,
    //   "total_sum": price ? price : data.price,
    //   "currency": "USD",
    //   "description": data.title_ru,
    //   "return_url": "https://www.VIA LUXE TOUR.uz/",
    //   // "notify_url": "https://webhook.site/7e378456-96f4-4aa2-b531-a9bd2cf66bc3",
    //   "language": "ru"
    // }
    // await axios.post("https://secure.octo.uz/prepare_payment", form_data).then((res)=>{
    //   console.log(res, 'res')
    //   window.open(res.data.octo_pay_url)
    // }).catch((err)=>{
    //   console.log(err)
    // })
  };

  return (
    <>
      <SweetAlert
        danger
        confirmBtnText="ok"
        confirmBtnBsStyle="danger"
        title={t("not")}
        show={notSuccess}
        onConfirm={() => window.location.reload()}
        focusCancelBtn
      />
      <SweetAlert
        success
        title={t("msent")}
        show={success}
        onConfirm={() => window.location.reload()}
      />
      <SweetAlert
        title={t("info")}
        show={bookShow}
        onCancel={() => setBookShow(false)}
        showConfirm={false}
      >
        <div>
          <form onSubmit={formBtn}>
            <input className="form-control" placeholder={t("name")} required />
            <input
              className="form-control"
              style={{ margin: "10px 0px" }}
              placeholder={t("surname")}
              required
            />
            <input
              className="form-control"
              style={{ margin: "10px 0px" }}
              placeholder={t("number")}
              required
            />
            <button
              className="money glow-on-hover"
              style={{ color: "black", backgrounColor: "white" }}
              onClick={() => {}}
            >
              {t("send")}
            </button>
          </form>
        </div>
      </SweetAlert>
      <SweetAlert
        title={"Payment wih PAYME"}
        show={paymeShow}
        onCancel={() => setPaymeShow(false)}
        showConfirm={false}
      >
        <div>
          <input
            className="form-control"
            placeholder={"Full name"}
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <input
            className="form-control"
            style={{ margin: "10px 0px" }}
            placeholder={"Phone Number"}
            value={phoneNumber}
            onChange={(e) => {
              setPhoneNumber(e.target.value);
            }}
          />
          <form method="POST" action="https://checkout.paycom.uz">
            {" "}
            <input
              type="hidden"
              name="merchant"
              defaultValue="64b27ea2d2cbaa16838ebe1e"
            />{" "}
            <input
              type="hidden"
              name="amount"
              defaultValue={Number(data.price * 11700) + "00"}
            />{" "}
            <input
              type="hidden"
              name="account[nazvaniya]"
              defaultValue={name}
            />{" "}
            <input
              type="hidden"
              name="account[Nomer]"
              defaultValue={phoneNumber}
            />{" "}
            <input
              type="hidden"
              name="account[sum]"
              defaultValue={Number(data.price * 11700) + "00"}
            />{" "}
            <button type="submit" className="money glow-on-hover">
              {" "}
              <img src={Payme || "/placeholder.svg"} alt="Payme" />{" "}
            </button>{" "}
          </form>
          {/* <form method="POST" action="https://checkout.paycom.uz"> <input type="hidden" name="merchant" value="64b27ea2d2cbaa16838ebe1e"/> <input type="hidden" name="amount" value="100000"/> <input type="hidden" name="account[nazvaniya]" value="aZIMJON"/> <input type="hidden" name="account[Nomer]" value="998909541262"/> <button type="submit" style="cursor: pointer;border: 1px solid #ebebeb;border-radius: 6px;background: linear-gradient(to top, #f1f2f2, white);width: 200px;height: 42px;display: flex;align-items: center;justify-content: center;"> <img style="width: 160px;height: 20px;" src="http://cdn.payme.uz/buttons/buttonbig_EN.svg"/> </button> </form> */}
        </div>
      </SweetAlert>
      <SweetAlert
        title={"Payment wih Click"}
        show={clickShow}
        onCancel={() => setClickShow(false)}
        showConfirm={false}
      >
        <div>
          <input
            className="form-control"
            placeholder={"Full name"}
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <input
            className="form-control"
            style={{ margin: "10px 0px" }}
            placeholder={"Phone Number"}
            value={phoneNumber}
            onChange={(e) => {
              setPhoneNumber(e.target.value);
            }}
          />
          <form
            id="click_form"
            className="text-center  w-80 text-white rounded-md cursor-pointer  text-3xl font-bold"
            action="https://my.click.uz/services/pay"
            method="get"
            target="_blank"
          >
            <input
              type="hidden"
              name="amount"
              value={data.price * dollar * 1000}
            />
            <input type="hidden" name="merchant_id" value="20898" />
            <input type="hidden" name="merchant_user_id" value="33539" />
            <input type="hidden" name="service_id" value="28519" />
            <input type="hidden" name="transaction_param" value={name} />
            <input
              type="hidden"
              name="return_url"
              value={companyInfo.website}
            />
            <input type="hidden" name="card_type" value="uzcard" />
            <button type="submit" className="money glow-on-hover">
              {" "}
              <img src={Klik || "/placeholder.svg"} alt="Click" />{" "}
            </button>{" "}
          </form>
        </div>
      </SweetAlert>
      {isloading ? (
        <div className="load-wrap">
          <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      ) : (
        <>
          <Nav />
          <head>
            <link
              href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css"
              rel="stylesheet"
              integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65"
              crossorigin="anonymous"
            />
          </head>
          {/* endnav */}
          <div className="container hihello" style={{ marginBottom: "6rem" }}>
            <div className="leftg">
              <img
                src={`${data.img}`}
                alt="Hawaii"
                style={{ borderRadius: "10px" }}
              />
            </div>
            <div className="rightg">
              <h2>
                {lang === "en" && data.title_eng}
                {lang === "ru" && data.title_ru}
                {lang === "uz" && data.title_uz}
              </h2>
              <p></p>
              <p>
                {data.location}
                <br />
                {price ? price : data.price} $
                <br />
                <div
                  dangerouslySetInnerHTML={{
                    __html: removeStrongTags(
                      lang === "en"
                        ? data.description_eng
                        : lang === "uz"
                        ? data.description_uz
                        : data.description_ru
                    ),
                  }}
                ></div>
              </p>
              <div className="money-wrap">
                {/* <button
                  className="money glow-on-hover"
                  onClick={() => {
                    setClickShow(true);
                  }}
                >
                  <img src={Klik || "/placeholder.svg"} alt="" />
                </button> */}
                {/* <button
                  className="money glow-on-hover"
                  onClick={() => {
                    setPaymeShow(true);
                  }}
                >
                  <img src={Payme || "/placeholder.svg"} alt="" />
                </button> */}
                <button
                  className="money glow-on-hover"
                  style={{ color: "black", backgrounColor: "white" }}
                  onClick={() => {
                    setBookShow(true);
                  }}
                >
                  {t("book")}
                </button>
                <Link to="https://payme.uz/fallback/merchant/?id=686e2da4b020ef438dae6aab">
                  {" "}
                  <button
                    className="money glow-on-hover"
                    style={{ color: "black", backgrounColor: "white" }}
                    onClick={() => {
                      Pay();
                    }}
                  >
                    {t("pay")}
                  </button>
                </Link>
                {/* <button className="money glow-on-hover"> */}
                {/* <form method="POST" action="https://checkout.paycom.uz">
                  {" "}
                  <input
                    type="hidden"
                    name="merchant"
                    defaultValue="63aae1344f030ccf8231ff03"
                  />
                  {" "}
                  <input
                    type="hidden"
                    name="amount"
                    defaultValue={data.price*dollar*100000}
                  />
                  {" "}
                  <input
                    type="hidden"
                    name="account[ISM]"
                    defaultValue="Azimjon Bekmuratov"
                  />
                  {" "}
                  <input
                    type="hidden"
                    name="account[Tel]"
                    defaultValue={"+998909541262"}
                  />
                  {" "}
                  <input
                    type="hidden"
                    name="account[sum]"
                    defaultValue={10000}
                  />
                  {" "}
                  <button
                    type="submit"
                    className="money glow-on-hover"
                  >
                    {" "}
                    <img
                      src={Payme || "/placeholder.svg"}
                    />
                    {" "}
                  </button>
                  {" "}
                </form> */}
                {/* <img src={Payme || "/placeholder.svg"} alt="" />
                </button> */}
              </div>
            </div>
          </div>
          <Footer />
        </>
      )}
    </>
  );
};

export default OneTour;
